import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import FilterGroup from 'components/search_sidebar/filter_group';
import FilterRow from 'components/search_page/filter_row';
import FilterTopbar from 'components/search_page/filter_topbar';
import Tag from 'components/tags/tag';

import { toggleView as toggleViewDuplicates } from '../../store/actions/duplicates';

export class DuplicatesPageTopbar extends React.Component {
  static propTypes = {
    onToggleFindDuplicates: PropTypes.func.isRequired
  };

  handleHideDuplicatesView = () => {
    this.props.onToggleFindDuplicates(false);
  };

  render() {
    return (
      <FilterTopbar>
        <FilterRow>
          <div className="hidden-xs hidden-sm">
            <div className="left-buffer-md container-fluid">
              <FilterGroup filtersApplied>
                <div className="top-buffer-xs d-inline-block">
                  <span className="text-muted">CURRENT FILTERS: </span>
                  <Tag name="duplicates-tag" removable onRemove={this.handleHideDuplicatesView}>Duplicates</Tag>
                </div>
                <div
                  className="clear-filter-tag clickable d-inline-block left-buffer-md"
                  name="clear-all-filters-button"
                  onClick={this.handleHideDuplicatesView}
                >
                  <FontAwesomeIcon className="right-buffer-sm" icon={faTimes} size="sm"/>
                  Clear All
                </div>
              </FilterGroup>
            </div>
          </div>
        </FilterRow>
      </FilterTopbar>
    );
  }
}

const mapDispatchToProps = {
  onToggleFindDuplicates: toggleViewDuplicates
};

export default connect(null, mapDispatchToProps)(DuplicatesPageTopbar);
